/* eslint-disable no-magic-numbers */
import {
  Button,
  Inline,
  Modal,
  type ModalProps,
  Typography,
} from '@omnipresentgroup/design-system';

export const MODAL_TITLE = 'Cancel invoice';

export type ContractorInvoiceCancellationModal = {
  modalProps: Omit<ModalProps, 'children'>;
  handleCancel: (event: React.SyntheticEvent) => void;
  handleSubmit: (event: React.SyntheticEvent) => void;
  loading?: boolean;
  invoiceRef: string;
};

export const ContractorInvoiceCancellationModal = (
  props: ContractorInvoiceCancellationModal,
) => {
  const { modalProps, handleCancel, handleSubmit, loading, invoiceRef } = props;

  const modalDescription = `${invoiceRef}`;
  return (
    <Modal {...modalProps} span={1}>
      <Modal.Header title={MODAL_TITLE} description={modalDescription} />

      <Modal.Body>
        <Typography as="span" size="14">
          Are you sure you wish to cancel this invoice?
        </Typography>
      </Modal.Body>

      <Modal.Footer>
        <Inline justify="space-between" w="stretch">
          <Button variant="secondary" onClick={handleCancel} disabled={loading}>
            No
          </Button>
          <Button variant="primary" onClick={handleSubmit} loading={loading}>
            Yes
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
